import { useEffect } from 'react';
import { useDispatch, useSelector } from 'src/store/store';
import { setCurrentTab } from 'src/modules/user/profile/actions';
import ProfileAbout from 'src/modules/user/profile/components/profileAbout';
import ProfilePosts from 'src/modules/user/profile/components/profilePosts';
import ProfileReplies from 'src/modules/user/profile/components/profileReplies';
import ProfileConnections from 'src/modules/user/profile/components/profileConnections';
import { ProfileTab } from 'src/constants/types';
import { useMediaQuery } from 'src/utils/mediaQuery';
export function CurrentTab() {
  const dispatch = useDispatch();
  const currentTab = useSelector(({
    pages
  }) => pages.profile.currentTab);
  const isDesktop = useMediaQuery('overScreenMedium');
  useEffect(() => {
    if (currentTab === ProfileTab.About && isDesktop) {
      // About tab shown as sidebar on desktop
      dispatch(setCurrentTab(ProfileTab.Posts));
    }
  }, [currentTab, dispatch, isDesktop]);
  switch (currentTab) {
    case ProfileTab.Posts:
      return <ProfilePosts />;
    case ProfileTab.Replies:
      return <ProfileReplies />;
    case ProfileTab.Connections:
      return <ProfileConnections />;
    case ProfileTab.About:
    default:
      return <ProfileAbout />;
  }
}